import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InstrumentAndPlanHelper } from '../instrument-and-plan-helper';
import { CurrencyPipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { CourtDocumentsComponent } from '../court-documents/court-documents';
import { CdkTableModule } from '@angular/cdk/table';
import { columns } from 'ngx-bootstrap-icons';

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

@Component({
  selector: 'app-rights-offering-view',
  imports: [
    CurrencyPipe,
    DecimalPipe,
    NgTemplateOutlet,
    CdkTableModule,
    CourtDocumentsComponent,
  ],
  templateUrl: './rights-offering-view.component.html',
  styleUrl: './rights-offering-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RightsOfferingViewComponent extends InstrumentAndPlanHelper {
  public rightsOffering = input.required<any>()
  public situationID = input.required<number>()

  public getPopulatedColumns(array: any[], ignoreColumns: any = {}): string[] {
    let columnsInUse: { [key: string]: boolean } = {}
    for (const row of array) {
      for (const [key, value] of (Object.entries(row) as Entries<typeof row>)) {
        if (value !== null && value.length > 0 && !ignoreColumns[key]) {
          columnsInUse[key] = true
        }
      }
    }
    return Object.keys(columnsInUse)
  }
}
